import { useCallback, useEffect, useState } from "react";
import { algoliasearch } from "algoliasearch";
import { SearchClient } from "@algolia/client-search";

export const useAlgoliaClient = (
  algolia: { app_id: string; api_key: string },
  requestParams: any = {},
  {
    showResultsByDefault,
  }: {
    showResultsByDefault: boolean;
  } = { showResultsByDefault: false }
) => {
  const [algoliaClient, setAlgoliaClient] = useState<SearchClient | null>(null);
  const [version, setVersion] = useState(0);

  const initClient = useCallback(() => {
    if (algolia) {
      const _ = algoliasearch(algolia.app_id, algolia.api_key);

      const searchClient = {
        ..._,
        search(requests) {
          if (!showResultsByDefault) {
            if (requests.every(({ params }) => !params.query)) {
              return Promise.resolve({
                results: requests.map(() => ({
                  hits: [],
                  nbHits: 0,
                  nbPages: 0,
                  page: 0,
                  processingTimeMS: 0,
                  hitsPerPage: 0,
                  exhaustiveNbHits: false,
                  query: "",
                  params: "",
                })),
              });
            }
          }

          const requestsWithFilters = requests.map((r) => {
            return {
              ...r,
              params: {
                ...r.params,
                ...requestParams,
              },
            };
          });

          return _.search(requestsWithFilters);
        },
      };
      setVersion((version) => version + 1);
      //@ts-ignore
      setAlgoliaClient(searchClient);
      console.log("Init algolia client");
    } else {
      console.log("Could not init algolia client");
    }
  }, [setAlgoliaClient, algolia]);

  useEffect(() => {
    initClient();
  }, [algolia]);

  const resetClient = useCallback(async () => {
    await initClient();
  }, [algolia, initClient]);

  return {
    algoliaClient: algoliaClient as ReturnType<typeof algoliasearch>,
    version,
    initClient,
    resetClient,
  };
};
